/*
 * NOTE: If updating the way we insert placeholder blots into the editor,
 * please check Nut_HTMLParser::hasPlaceholderTags and update it as well if
 * neccessary. This is our final safeguard on the backend to ensure we don't
 * accidentally send out emails with placeholders and cause user embarrasment.
 *
 * https://github.com/nutshellcrm/nutshell/blob/7473d1fe0c7d85a26e3abd32b4d0b6a544635c62/library/Nut/HTMLParser.php#L213-L228
 */

const placeHolders = [
    {
        id: 'firstName',
        label: 'First name',
    },
    {
        id: 'lastName',
        label: 'Last name',
    },
    {
        id: 'companyName',
        label: 'Company name',
    },
];

/**
 * Add the placeholder blots into text with the text variable placeholders
 *
 * @param  {string} html Text with string placeholders eg. {firstName}
 * @return {string}      Text with blots for varaibles
 */
export function addPlaceholderBlots(html: string): string {
    let htmlWithBlots = html;
    placeHolders.forEach((placeHolder) => {
        htmlWithBlots = htmlWithBlots.replace(
            new RegExp(`{${placeHolder.id}}`, 'g'),
            `<span class="ql-placeholder-blot" data-id="${placeHolder.id}" data-label="${placeHolder.label}" spellcheck="false"><span contenteditable="false">${placeHolder.label}</span></span>`
        );
    });

    const fragment = new DOMParser()
        .parseFromString(htmlWithBlots, 'text/html')
        .getElementsByTagName('body')[0];

    // Replace custom placeholders
    // @ts-expect-error
    const customPlaceholderElements = fragment.getElementsByClassName('NUT-custom-placeholder');
    // Loop in reverse order since we're removing elements from this list
    for (let i = customPlaceholderElements.length - 1; i >= 0; --i) {
        const element = customPlaceholderElements[i];
        if (element) {
            const parentElement = element.parentElement;
            // @ts-expect-error
            const label = element.innerText;
            const dataId = element.getAttribute('id');
            if (parentElement && dataId && label) {
                const newOuterNode = document.createElement('span');
                newOuterNode.className = 'ql-placeholder-blot-custom';
                newOuterNode.setAttribute('data-id', dataId);
                newOuterNode.setAttribute('data-label', dataId);
                newOuterNode.setAttribute('spellcheck', 'false');

                const newInnerNode = document.createElement('span');
                newInnerNode.setAttribute('contenteditable', 'false');
                newInnerNode.textContent = label;
                newOuterNode.appendChild(newInnerNode);

                parentElement.insertBefore(newOuterNode, element);
                parentElement.removeChild(element);
            }
        }
    }

    // @ts-expect-error
    return fragment.innerHTML;
}

/**
 * Remove placeholder blots from text
 *
 * @param  {string} html The html string with blots on it
 * @return {string}      The html string with text variables instead of blots
 */
export function scrubEmailHtmlPlaceholders(html: string): string {
    const fragment = new DOMParser()
        .parseFromString(html, 'text/html')
        .getElementsByTagName('body')[0];

    // Replace built-in placeholders
    // @ts-expect-error
    const placeholderElements = fragment.getElementsByClassName('ql-placeholder-blot');
    // Loop in reverse order since we're removing elements from this list
    for (let i = placeholderElements.length - 1; i >= 0; --i) {
        const element = placeholderElements[i];
        if (element) {
            const parentElement = element.parentElement;
            const dataId = element.getAttribute('data-id');
            if (parentElement && dataId) {
                const newNode = document.createTextNode(`{${dataId}}`);
                parentElement.insertBefore(newNode, element);
                parentElement.removeChild(element);
            }
        }
    }

    // Replace custom placeholders
    // @ts-expect-error
    const customPlaceholderElements = fragment.getElementsByClassName('ql-placeholder-blot-custom');
    // Loop in reverse order since we're removing elements from this list
    for (let i = customPlaceholderElements.length - 1; i >= 0; --i) {
        const element = customPlaceholderElements[i];
        if (element) {
            const parentElement = element.parentElement;
            const innerSpan = element.getElementsByTagName('span')[0];
            const dataId = element.getAttribute('data-id');
            if (parentElement && innerSpan && dataId) {
                const newNode = document.createElement('span');
                newNode.className = 'NUT-custom-placeholder';
                newNode.id = dataId;
                newNode.textContent = innerSpan.textContent;
                parentElement.insertBefore(newNode, element);
                parentElement.removeChild(element);
            }
        }
    }

    // @ts-expect-error
    return fragment.innerHTML;
}
